<p-dialog [header]="isShowMatch == '1' ? 'マッチング依頼詳細' : 'ふれあい体験希望詳細'" [(visible)]=" boardFlag" [modal]="true"
  [responsive]="true" [styleClass]="'main-dialog dialog-c431'" (onHide)="closeDialog()">
  <div class="main-height">
    <!-- メイン -->

    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="p-fluid p-formgrid p-grid screen-support">
        <div class="p-col-12">
          <div class="p-fluid p-formgrid p-grid support-header">
            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <p-card class="support-header-card">
                <div class="support-header-card-show">
                  <div class="p-fluid p-formgrid p-grid support-header-card-detail">
                    <div class="p-col-4 image">
                      <div class="support-header-card-detail-img" [ngStyle]="{
                          'background-image':
                            'url(' + detailTask?.icon_image + ')'
                        }"></div>
                    </div>
                    <div class="p-col-8 support-desc">
                      <div class="support-description-detail">
                        <span class="support-tag-category pink-color-c431">{{
                          detailTask?.class_sub_id }}</span>
                        <span class="support-large-title primary-title p-text-bold"
                          [pTooltip]="detailTask?.municipalities + ' ' + detailTask?.organization_name"
                          #organization_name [tooltipDisabled]="!isOverflow(organization_name)">{{
                          detailTask?.municipalities + ' ' + detailTask?.organization_name
                          }}</span>
                        
                         <div class="support-sub-title" [pTooltip]="detailTask?.oneword_message" #oneword_message
                          [tooltipDisabled]="!isOverflow(oneword_message)">
                          <span>{{ detailTask?.oneword_message }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </p-card>
            </div>
            <!-- 団体情報の追加表示 -->
            <div class="p-col-12">
              <span class="p-text-bold">団体情報</span>
            </div>

            <div class="p-col-12">
              <div class="support-separate"></div>
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-first">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">団体区分詳細</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ isShowMatch == '1' ? matchInfo?.class_sub_id : detailTask?.class_sub_id }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-third">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">団体名</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ isShowMatch == '1' ? matchInfo?.organization_name : detailTask?.organization_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-second">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview no-wrap">所在地(市区町村)
                      </span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ isShowMatch == '1' ? matchInfo?.municipalities : detailTask?.municipalities }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview no-wrap">所在地<br>&nbsp;(それ以降の住所)</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ isShowMatch == '1' ? matchInfo?.address_building : detailTask?.address_building }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">電話番号</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ isShowMatch == '1' ? matchInfo?.tel : detailTask?.tel }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-sub">※各団体へのお問い合わせは、急ぎの場合を除き、原則、本システム内のチャットでお願いします。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <!-- ここまで、以下は依頼内容 or 希望内容 -->
            <div class="p-col-12">
              <span class="p-text-bold seperate">{{ isShowMatch == '1' ? '依頼内容' : "希望内容"}}</span>
            </div>
            <div class="p-col-12">
              <div class="support-separate"></div>
            </div>

            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">{{ match_type == '1' ? '参加乳幼児の年齢' : "参加生徒の学年"}}</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.target_grade }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" *ngIf="isShowMatch == '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">希望時期・日数</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ matchInfo?.desired_ldatetime }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">{{ match_type == '1' ? '参加乳幼児数' : "参加生徒人数"}}</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.desired_people_number }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" *ngIf="isShowMatch == '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">{{ match_type == '1' ? '参加生徒学年・人数' : "参加乳幼児の年齢・人数"}}</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ matchInfo?.desired_lpeople_number }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">希望時期・日数</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.desired_datetime }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" *ngIf="isShowMatch == '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">実施場所希望</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ matchInfo?.desired_location }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">実施場所</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.desired_location }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" *ngIf="isShowMatch == '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">希望する体験の概要</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ matchInfo?.desired_content }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="isShowMatch != '1' && match_type == '1'">
              <div class="p-col-12">
                <hr class="sperate-between-line" />
              </div>

              <div class="p-col-12" *ngIf="isShowMatch != '1'">
                <div class="support-table-detail">
                  <div class="support-line-sixth">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-3 large-title">
                        <span class="title-overview">園・施設で受け入れる場合に、一度に対応可能な生徒数の規模</span>
                      </div>
                      <div class="p-col-9 description-title-overview">
                        <span>
                          {{ detailTask?.expected_people_number }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12" *ngIf="isShowMatch != '1'">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">実施可能曜日</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.desired_dayweek }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" *ngIf="isShowMatch == '1'">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">担当者氏名</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ matchInfo?.manager_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="isShowMatch != '1'">
              <div class="p-col-12">
                <hr class="sperate-between-line" />
              </div>

              <div class="p-col-12">
                <div class="support-table-detail">
                  <div class="support-line-sixth">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-3 large-title">
                        <span class="title-overview">実施希望時間</span>
                      </div>
                      <div class="p-col-9 description-title-overview">
                        <span>
                          {{ detailTask?.desired_time }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-col-12">
                <hr class="sperate-between-line" />
              </div>

              <div class="p-col-12">
                <div class="support-table-detail">
                  <div class="support-line-sixth">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-3 large-title">
                        <span class="title-overview">希望の詳細</span>
                      </div>
                      <div class="p-col-9 description-title-overview">
                        <span>
                          {{ detailTask?.desired_content }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-col-12">
                <hr class="sperate-between-line" />
              </div>

              <div class="p-col-12">
                <div class="support-table-detail">
                  <div class="support-line-sixth">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-3 large-title">
                        <span class="title-overview">その他、補足事項</span>
                      </div>
                      <div class="p-col-9 description-title-overview">
                        <span>
                          {{ detailTask?.remark }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-col-12">
                <hr class="sperate-between-line" />
              </div>

              <div class="p-col-12">
                <div class="support-table-detail">
                  <div class="support-line-sixth">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-3 large-title">
                        <span class="title-overview">担当者氏名</span>
                      </div>
                      <div class="p-col-9 description-title-overview">
                        <span>
                          {{ detailTask?.manager_name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="p-col-12">
              <div class="support-separate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>